import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { Store } from '@ngrx/store';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { UserGridItemObject, UserGridObject } from '@it2go/types';
import { UserService } from '../../../../../services/user.service';
import { selectServices } from '../../../../../store/global/global.selectors';
import { OrganizationService } from '../../../../../services/organization.service';
import { AclService } from '../../../../../services/acl.service';
import { UserWorkplaceGridObject } from '@libs/types/src/user/object-type/workplace/user-workplace.object';

interface State {
    users: UserGridObject | null,
    userWorkplaces: UserWorkplaceGridObject | null,

}

const defaultState: State = {
    users: null,
    userWorkplaces: null,
};

@Injectable()
export class UserPageStore extends ComponentStoreFactory<State> {

    public services$ = this.globalStore!.select(selectServices);
    public user$: Observable<UserGridItemObject | null> = this.data.users$.firstGridItem();

    constructor() {
        super(defaultState, inject(Store), inject(UserService), inject(OrganizationService), inject(AclService));
    }

}
